'use strict';

angular.module('searchModule')

.controller('RefineFacetRiskRatingController', ['$scope', 'commonRiskSelfAssessmentService', function ($scope, commonRiskSelfAssessmentService) {

    commonRiskSelfAssessmentService.getAllCriterias()
        .then(function (criterias) {
            $scope.criterias = criterias;
        });

    $scope.getLabelFacet = function () {

        var refineFacetConfig = _.find($scope.facetConfiguration.RefineFacets, {
            RefineFacetID: $scope.refineFacetsByColumnValue.RefineFacetID
        });

        var lookupTypeName = 'Probability';

        if (refineFacetConfig.Name === 'Severity Risk Rating') lookupTypeName = 'Severity';
        if (refineFacetConfig.Name === 'Mitigation Risk Rating') lookupTypeName = 'Mitigation';
        if (refineFacetConfig.Name === 'Overall Risk Rating') lookupTypeName = 'Overall';

        var criteria = _.find($scope.criterias, {
            RiskLookupAssessmentTypeName: lookupTypeName,
            Code: $scope.refineFacetsByColumnValue.ColumnValue
        });

        if (_.isUndefined(criteria)) return undefined;

        var labelFacet = criteria.Name.replace(/<[^>]*>/i, ' ');

        return labelFacet;
    }

}]);